import React from 'react'
import Button from './Button'

import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'

import { formattedMessage } from '../CurrentLocale'

type Props = {
  open: boolean,
  onClose: Function,
  message: string,
  children?: any,
  title?: string,
  maxWidth?: string,
  buttonValid?: string,
  buttonClose?: string,
  onValid?: Function,
}

const AlertDialog = ({
  open,
  onValid = (noop) => noop,
  onClose = (noop) => noop,
  buttonValid = formattedMessage({ id: 'ok' }),
  buttonClose = '',
  title = '',
  message = '',
  children = '',
  maxWidth = 'sm',
}: Props) => {
  return (
    <Dialog open={open} onClose={() => onClose()} fullWidth={true} maxWidth={maxWidth}>
      {title !== '' && <DialogTitle>{title}</DialogTitle>}
      <DialogContent>
        <DialogContentText data-testid={'dialog-content'}>{message}</DialogContentText>
        {!!children && (
          <DialogContentText data-testid={'dialog-content-children'}>{children}</DialogContentText>
        )}
      </DialogContent>
      <DialogActions
        style={{
          flexDirection: 'row',
          justifyContent: 'space-evenly',
        }}
      >
        {buttonClose !== '' && (
          <Button color={'secondary'} title={buttonClose} onClick={() => onClose()} />
        )}
        <Button
          testId={'dialog-button-ok'}
          title={buttonValid}
          color={'primary'}
          onClick={() => {
            !!onValid && onValid()
            onClose()
          }}
        />
      </DialogActions>
    </Dialog>
  )
}

export default AlertDialog
